// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container {
    display: flex;
    background-color: var(--darkGreen);
    min-height: 100vh;
}

.dashboard-container .left-container {
    width: 230px;
    position: fixed;
    left: 0;
    top: 0;
    height: 100%;
    overflow: auto;
    transition: all 0.4s ease-in-out;
}

.dashboard-container .right-container {
    width: calc(100% - 230px);
    margin-left: 230px;
    background-color: var(--lightBlack);
    border-radius: 20px 0px 0px 20px;
    padding: 23px 34px;
}

.dash-graph-container {
    display: flex;
}


.dash-graph-container .left-section .graph-img img {
    width: 100%;
}

.dash-graph-container .left-section .heading {
    color: var(--primeryColor);
    text-align: left;
    font-weight: 400;
}


.dash-graph-container .right-section .heading {
    color: var(--primeryColor);
    text-align: left;
    font-weight: 400;
}

.controller-status-card .cont-card {
    background-color: var(--darkGreen);
    border: 1px solid;
    border-color: var(--whiteLight);
    padding: 29px 27px;
    border-radius: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.controller-status-card .cont-card .total-assig-contoller {
    color: var(--whiteLight);
    text-align: left;
    font-weight: 400;
    font-family: 'Acumin Pro';
}

.controller-status-card .cont-card .count {
    color: var(--whiteLight);
    text-align: left;
    font-weight: bold;
}

.firstIndex {
    background-color: red;
}

.header-menu-toggle{
    display: none;
}`, "",{"version":3,"sources":["webpack://./src/Screens/Dashboard/Dashboard.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,kCAAkC;IAClC,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,OAAO;IACP,MAAM;IACN,YAAY;IACZ,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,mCAAmC;IACnC,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;;AAGA;IACI,WAAW;AACf;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,gBAAgB;AACpB;;;AAGA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,iBAAiB;IACjB,+BAA+B;IAC/B,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".dashboard-container {\n    display: flex;\n    background-color: var(--darkGreen);\n    min-height: 100vh;\n}\n\n.dashboard-container .left-container {\n    width: 230px;\n    position: fixed;\n    left: 0;\n    top: 0;\n    height: 100%;\n    overflow: auto;\n    transition: all 0.4s ease-in-out;\n}\n\n.dashboard-container .right-container {\n    width: calc(100% - 230px);\n    margin-left: 230px;\n    background-color: var(--lightBlack);\n    border-radius: 20px 0px 0px 20px;\n    padding: 23px 34px;\n}\n\n.dash-graph-container {\n    display: flex;\n}\n\n\n.dash-graph-container .left-section .graph-img img {\n    width: 100%;\n}\n\n.dash-graph-container .left-section .heading {\n    color: var(--primeryColor);\n    text-align: left;\n    font-weight: 400;\n}\n\n\n.dash-graph-container .right-section .heading {\n    color: var(--primeryColor);\n    text-align: left;\n    font-weight: 400;\n}\n\n.controller-status-card .cont-card {\n    background-color: var(--darkGreen);\n    border: 1px solid;\n    border-color: var(--whiteLight);\n    padding: 29px 27px;\n    border-radius: 10px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.controller-status-card .cont-card .total-assig-contoller {\n    color: var(--whiteLight);\n    text-align: left;\n    font-weight: 400;\n    font-family: 'Acumin Pro';\n}\n\n.controller-status-card .cont-card .count {\n    color: var(--whiteLight);\n    text-align: left;\n    font-weight: bold;\n}\n\n.firstIndex {\n    background-color: red;\n}\n\n.header-menu-toggle{\n    display: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
